import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77f76a4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-view" }
const _hoisted_2 = { class: "news-shell" }
const _hoisted_3 = { class: "page-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "eyebrow" }, "LATEST NOTICES", -1))
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "notice-heading" }
const _hoisted_7 = { class: "notice-date" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title-mark",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "detail-content" }
const _hoisted_11 = {
  key: 0,
  class: "detail-fields"
}
const _hoisted_12 = {
  key: 1,
  class: "detail-list"
}
const _hoisted_13 = {
  key: 0,
  class: "notice-closing"
}
const _hoisted_14 = {
  key: 0,
  class: "attachment-label"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pdf-type",
  "aria-hidden": "true"
}, "PDF", -1))
const _hoisted_17 = { class: "pdf-copy" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pdf-arrow",
  "aria-hidden": "true"
}, "↗", -1))

import { computed, onActivated, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

interface Field {
  label: string;
  value: string;
}

interface NoticeSection {
  heading: string;
  paragraphs?: string[];
  fields?: Field[];
  items?: string[];
}

interface NoticeAttachment {
  name: string;
  url: string;
}

interface Notice {
  id: string;
  date: string;
  title: string;
  detailTitle: string;
  intro: string[];
  sections: NoticeSection[];
  closing: string[];
  attachment?: NoticeAttachment;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsView',
  setup(__props) {

const { locale } = useI18n();
const route = useRoute();
const isZh = computed(() => locale.value === "zh");

const allNotices: Notice[] = [
  {
    id: "selection-notice",
    date: "2024.07.15",
    title: "三水数据中心机房运维服务项目·比选公告",
    detailTitle: "项目公开比选基本要素卡",
    intro: [],
    sections: [
      {
        heading: "项目要点",
        fields: [
          { label: "项目名称", value: "【三水数据中心机房运维服务项目】" },
          { label: "项目编号", value: "【BX-2024-0031】" },
          { label: "预算控制价", value: "【56】万元" },
          { label: "服务期限", value: "自合同签订之日起【12个月】" },
          {
            label: "服务核心",
            value: "网络/服务器/终端系统的日常驻场巡检、故障响应及技术支持",
          },
        ],
      },
      {
        heading: "参选资格",
        items: [
          "具备独立法人资质（提供营业执照复印件）；",
          "具有近3年同类IT驻场服务业绩及满意度证明；",
          "本项目不接受联合体参选。",
        ],
      },
      {
        heading: "时间与递交",
        fields: [
          {
            label: "报名及截止时间",
            value: "【2024年07月15日】至【2024年07月20日 17:00】",
          },
          { label: "材料递交邮箱", value: "【bxq0047@gmail.com】" },
        ],
      },
      {
        heading: "采购联系人",
        fields: [
          { label: "联系人", value: "【张经理】" },
          { label: "联系电话", value: "【13822393029】" },
        ],
      },
    ],
    closing: [],
  },
  {
    id: "award-announcement",
    date: "2024.08.01",
    title: "IT驻场运维服务项目·成交公示",
    detailTitle: "成交结果确认卡",
    intro: [
      "项目名称：【三水数据中心机房运维服务项目】（编号：BX-2024-0031）",
      "评审日期：【2024年07月28日】",
      "经比选小组综合评审，本项目成交结果如下：",
    ],
    sections: [
      {
        heading: "成交结果",
        fields: [
          { label: "成交供应商", value: "环迅通科技（北京）有限公司" },
          { label: "成交金额", value: "【54】万元" },
          { label: "服务周期", value: "【1年】" },
        ],
      },
      {
        heading: "异议反馈",
        paragraphs: [
          "本公示期为【3个工作日】（自【2024年08月01日】起）。如有异议，请在公示期内向采购人提交书面反馈。",
          "邮箱：【bxq0047@gmail.com】",
        ],
      },
    ],
    closing: [],
    attachment: {
      name: "成交结果通知书.pdf",
      url: "/documents/成交结果通知书.pdf",
    },
  },
];

const isAwardPage = computed(() => route.path === "/news/award");
const notices = computed(() =>
  allNotices.filter((notice) =>
    isAwardPage.value
      ? notice.id === "award-announcement"
      : notice.id === "selection-notice"
  )
);
const pageTitle = computed(() => {
  if (isAwardPage.value) {
    return isZh.value ? "成交公示" : "Award Notice";
  }
  return isZh.value ? "比选公告" : "Selection Notice";
});

onActivated(() => window.scrollTo({ top: 0 }));
watch(
  () => route.path,
  () => window.scrollTo({ top: 0 })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", null, _toDisplayString(pageTitle.value), 1)
      ]),
      _createElementVNode("section", {
        class: "notice-list",
        "aria-label": pageTitle.value
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value, (notice) => {
          return (_openBlock(), _createElementBlock("article", {
            key: notice.id,
            class: "notice-item"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(notice.date), 1),
                _createElementVNode("h2", null, _toDisplayString(notice.title), 1),
                _hoisted_8
              ])
            ]),
            _createElementVNode("div", {
              id: `${notice.id}-detail`,
              class: "notice-detail"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notice.intro, (paragraph) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: paragraph,
                  class: "intro-paragraph"
                }, _toDisplayString(paragraph), 1))
              }), 128)),
              _createElementVNode("h3", {
                class: _normalizeClass(["document-card-title", { 'without-intro': notice.intro.length === 0 }])
              }, _toDisplayString(notice.detailTitle), 3),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notice.sections, (section) => {
                return (_openBlock(), _createElementBlock("section", {
                  key: section.heading,
                  class: "detail-section"
                }, [
                  _createElementVNode("h3", null, _toDisplayString(section.heading), 1),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.paragraphs, (paragraph) => {
                      return (_openBlock(), _createElementBlock("p", { key: paragraph }, _toDisplayString(paragraph), 1))
                    }), 128)),
                    (section.fields)
                      ? (_openBlock(), _createElementBlock("dl", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: field.label,
                              class: "detail-field"
                            }, [
                              _createElementVNode("dt", null, _toDisplayString(field.label), 1),
                              _createElementVNode("dd", null, _toDisplayString(field.value), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (section.items)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                            return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              (notice.closing.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notice.closing, (line) => {
                      return (_openBlock(), _createElementBlock("p", { key: line }, _toDisplayString(line), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_9),
            (notice.attachment)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(isZh.value ? "附件" : "Attachment"), 1))
              : _createCommentVNode("", true),
            (notice.attachment)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "pdf-attachment",
                  href: notice.attachment.url,
                  target: "_blank",
                  rel: "noopener"
                }, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, [
                    _createElementVNode("strong", null, _toDisplayString(notice.attachment.name), 1),
                    _createElementVNode("small", null, _toDisplayString(isZh.value ? "点击查看 PDF 文件" : "Open PDF file"), 1)
                  ]),
                  _hoisted_18
                ], 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 8, _hoisted_5)
    ])
  ]))
}
}

})